import { useState } from "react";
import {
  RiMailLine,
  RiMessage2Line,
  RiWhatsappLine,
  RiSearchLine,
} from "react-icons/ri";

const MessageHistory = () => {
  const [filter, setFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  // Sample data - replace with API call
  const messages = [
    {
      id: 1,
      type: "email",
      subject: "Welcome to our service",
      recipients: 150,
      delivered: 148,
      opened: 89,
      clicked: 45,
      date: "2023-10-15 09:30",
      status: "delivered",
    },
    {
      id: 2,
      type: "sms",
      content: "Your order has been shipped!",
      recipients: 75,
      delivered: 75,
      date: "2023-10-14 15:20",
      status: "delivered",
    },
    {
      id: 3,
      type: "whatsapp",
      content: "Special offer: 20% off",
      recipients: 100,
      delivered: 98,
      read: 80,
      date: "2023-10-14 11:45",
      status: "delivered",
    },
  ];

  const getIcon = (type) => {
    switch (type) {
      case "email":
        return <RiMailLine className="w-5 h-5 text-primary" />;
      case "sms":
        return <RiMessage2Line className="w-5 h-5 text-success" />;
      case "whatsapp":
        return <RiWhatsappLine className="w-5 h-5 text-warning" />;
      default:
        return null;
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      delivered: "bg-success/10 text-success",
      failed: "bg-danger/10 text-danger",
      pending: "bg-warning/10 text-warning",
    };

    return (
      <span className={`px-2 py-1 rounded-full text-sm ${colors[status]}`}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between gap-4">
        <div className="relative flex-1">
          <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search messages..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border rounded-lg"
          />
        </div>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="p-2 border rounded-lg"
        >
          <option value="all">All Messages</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
        </select>
      </div>

      <div className="card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-4">Type</th>
                <th className="text-left p-4">Content</th>
                <th className="text-left p-4">Recipients</th>
                <th className="text-left p-4">Delivered</th>
                <th className="text-left p-4">Date</th>
                <th className="text-left p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((message) => (
                <tr key={message.id} className="border-b hover:bg-gray-50">
                  <td className="p-4">{getIcon(message.type)}</td>
                  <td className="p-4">
                    <div className="font-medium">
                      {message.subject || message.content}
                    </div>
                  </td>
                  <td className="p-4">{message.recipients}</td>
                  <td className="p-4">{message.delivered}</td>
                  <td className="p-4">{message.date}</td>
                  <td className="p-4">{getStatusBadge(message.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MessageHistory;
